import { useMutation } from '@tanstack/react-query';
import apiService from './apiServices';
import { apiServiceRTQ } from './apiShow';

/**
 * @namespace DeleteAllData
 * @description A collection of functions to handle data deletion operations.
 */
export const DeleteAllData = {
  /**
   * Deletes data by sending a DELETE request to the specified URL.
   *
   * @async
   * @function deleteData
   * @memberof DeleteAllData
   * @param {string} url - The URL to which the DELETE request will be sent.
   * @returns {Promise<Object>} The response from the API.
   */
  deleteData: async (url) => {
    return await apiServiceRTQ.delete(url);
  },
};

export const useDeleteApi = () => {
  return useMutation({
    mutationFn: (url) => apiServiceRTQ.delete(url),
    onSuccess: (data) => {},
    onError: (error) => {},
  });
};
